(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/track-successful-wagers.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/track-successful-wagers.js');

'use strict';

const _svs$components$analy = svs.components.analytics,
  AnalyticsTransactionItem = _svs$components$analy.transactionItem,
  AnalyticsTransaction = _svs$components$analy.transaction;
const formatCurrency = svs.utils.format.Currency;
function trackSuccessfulWagers(_ref) {
  let next = _ref.next,
    successfulWagers = _ref.successfulWagers;
  next();
  successfulWagers.forEach(successfulWager => {
    const wager = successfulWager.wager,
      wagerAmounts = successfulWager.wagerAmounts,
      wagerClientSerial = successfulWager.wagerClientSerial;
    const options = {
      prolong: wager.isProlongination ? '1' : '0',
      geoLocType: wager.pinLocationType,
      geoLocName: svs.tur.lyckoplatsen.utils.isDefaultLocationName(wager.lyckoplatsenName) ? 'CTA_spela' : 'CTA_spelaName',
      reverseGeo: wager.pinLocationType === 'HOME' ? '' : wager.locationName,
      activeLoc: undefined,
      rounds: wager.numberOfWeeks
    };
    if (wager.isProlongination && wager.prolongOriginalWager) {
      options.retailCampaign = wager.prolongOriginalWager.totalDrawCount === 1 ? 'yes' : 'no';
    }
    const item = new AnalyticsTransactionItem('LYCKOPLATSEN', 'Lyckoplatsen', formatCurrency(wagerAmounts.totalAmount), 1, options);
    const transaction = new AnalyticsTransaction(wagerClientSerial, formatCurrency(wagerAmounts.totalAmount), [item], 0, 0, undefined, 'LYCKOPLATSEN');
    svs.components.analytics.trackTransaction(transaction);
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  trackSuccessfulWagers
});

 })(window);